module.exports = __webpack_public_path__ + "static/media/instrucciones.f94da758.png";